import { Field } from 'queries';

export const getFieldIndex = (fields: Field[], field: Field) => {
  return fields.findIndex(
    f => f.ref === field.ref || (f.id && f.id === field.id),
  );
};
